import { osName, appName } from "@/utils/device";
import crypto from "@/utils/crypto";
import axios from "axios";
import { getCookie } from "@/utils/cookie";

axios.defaults.timeout = 10000;
axios.defaults.withCredentials = true;

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export function sleep(time) {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
}

/**
 * 产生min到max的随机时间,向下舍入
 *
 * @return {number}  { min到max的随机时间 }
 */
export function random(min = 0, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

export function openOrDownloadKy(url) {
  // 应用宝下载链接
  const yingyongbao = `https://a.app.qq.com/o/simple.jsp?pkgname=com.kwai.videoeditor${
    url ? "&android_schema=" + encodeURIComponent(url) : ""
  }`;
  const ios = "https://itunes.apple.com/cn/app/id1195860596";
  const android =
    appName === "wechat"
      ? yingyongbao
      : "market://details?id=com.kwai.videoeditor";
  if (appName === "qq") {
    location.href = osName === "ios" ? ios : android;
  } else {
    location.href = url;
    setTimeout(() => {
      if (!document.hidden) {
        location.href = osName === "ios" ? ios : android;
      }
    }, 2000);
  }
}

const baseUrlMap = process.env.KyApi;
const HOST =
  window.location.hostname.indexOf("kittyfunny.com") > -1
    ? "https://g-api.kittyfunny.com"
    : baseUrlMap.HOST || "https://api.kmovie.gifshow.com";

// post 请求
export function post(url, data = {}) {
  const did = getCookie("did") || getCookie("_did") || "";
  const postData = {
    did,
    ...data,
  };
  console.log("post json", JSON.stringify(data));
  return axios({
    method: "post",
    url: `${HOST}${url}`,
    data: postData,
    params: crypto("yiuhjkbvhbjisjchgdnx38uejd"),
  });
}

// get请求
export function get(url, query = {}) {
  const webId = getCookie("did") || getCookie("_did") || "";
  console.log("get did:", webId);
  return axios({
    method: "get",
    url: `${HOST}${url}`,
    params: {
      webId,
      ...query,
      ...crypto("yiuhjkbvhbjisjchgdnx38uejd"),
    },
    headers: {
      "trace-context": JSON.stringify({ laneId: "PRT.test" }),
    },
  });
}

//toast
export function toast(info = "", type = "") {
  const toastBox = document.createElement("div");
  toastBox.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
  toastBox.style.borderRadius = "0.6rem";
  toastBox.style.position = "fixed";
  toastBox.style.top = "40%";
  toastBox.style.left = "50%";
  toastBox.style.width = "fit-content";
  toastBox.style.transform = "translateX(-50%)";
  toastBox.style.textAlign = "center";
  toastBox.style.color = "rgba(255, 255, 255, 0.9)";
  toastBox.style.fontSize = "0.28rem";
  toastBox.style.zIndex = "9999";
  toastBox.style.padding = type === "dom" ? "0" : "0.3rem 0.6rem";
  toastBox.innerHTML = info;
  document.body.appendChild(toastBox);
  setTimeout(() => {
    document.body.removeChild(toastBox);
  }, 2500);
}

/* did兜底:生成唯一游客uid */
export const getUUID = () => {
  let uuid_token = localStorage.getItem("UUIDTOKEN");
  if (!uuid_token) {
    uuid_token = newUid();
    localStorage.setItem("UUIDTOKEN", uuid_token);
  }
  return uuid_token;
};

function newUid() {
  let s = [];
  let hexDigits = "0123456789abcdef";
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
  s[8] = s[13] = s[18] = s[23] = "-";

  let uuidA = s.join("");
  return uuidA;
}
